import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, token: String }

  close () {
    if (!confirm("Are you sure you want to close this training?")) return

    this.sendExit()
    window.close()

    // window.close() may be blocked by the browser if the script didn't
    // open the window. Replace the page content so the user can't continue.
    document.body.innerHTML = `
      <div style="display:flex; align-items:center; justify-content:center; height:100vh; text-align:center;">
        <div>
          <h3>Training Session Ended</h3>
          <p>You may now close this window.</p>
        </div>
      </div>
    `
  }

  sendExit (event) {
    if (event?.persisted) return
    if (this.exited) return
    this.exited = true

    const formData = new FormData()
    if (this.hasTokenValue && this.tokenValue) {
      formData.append("lms_session_token", this.tokenValue)
    }

    navigator.sendBeacon(this.urlValue, formData)
  }
}
